import { Button, Layout, Spin } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useForm } from 'antd/es/form/Form'
import { get, put } from '../../Common/api'
import { t } from 'i18next'
import OwnerForm from '../OwnersPage/OwnerForm'
import GlobalContext from '../GlobalContext'

export default function OwnerPage () {
  const { id } = useParams()
  const [form] = useForm()
  const [loading, setLoading] = useState(false)
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    getOwner()
  }, [])

  const getOwner = async () => {
    setLoading(true)
    await get({
      url: `admin/owners/${id}`,
      params: {},
      onSuccess: (json) => {
        setLoading(false)
        form.setFieldsValue(json)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const onFinish = (values) => {
    saveOwner(values)
  }

  const saveOwner = (params) => {
    setLoading(true)
    put({
      url: `admin/owners/${id}`,
      params,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: () => {
        setLoading(false)
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white', marginTop: '2em' }}>
      <Spin spinning={loading}>
          <OwnerForm form={form} edit={true} onFinish={onFinish} />
          <Button type="primary" htmlType="submit" onClick={form.submit}>
            {t('Admin.btn.submit')}
          </Button>
      </Spin>
    </Layout>
  )
}
